import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import {
  DEFAULT_LOCALE,
  getLangParam,
  isSupportedLocale,
  withLangParam,
} from '../../utils/language';

const LanguageParamSync = () => {
  const location = useLocation();
  const history = useHistory();
  const { i18n } = useTranslation();

  useEffect(() => {
    const urlLanguage = getLangParam(location.search);

    if (isSupportedLocale(urlLanguage)) {
      if (urlLanguage !== i18n.language) {
        i18n.changeLanguage(urlLanguage);
      }
      return;
    }

    const language = urlLanguage === null ? i18n.language : DEFAULT_LOCALE;

    history.replace({
      pathname: location.pathname,
      search: withLangParam(location.search, language),
      hash: location.hash,
      state: location.state,
    });

    // reloads the page, so the url has to be updated first
    if (language !== i18n.language) {
      i18n.changeLanguage(language);
    }
  }, [location, history, i18n]);

  return null;
};

export default LanguageParamSync;
